"use client";
import { gradientTextLeftToRightStyles } from "@/data/styles.data";
import React from "react";
import { IoIosArrowRoundUp } from "react-icons/io";
import { bannerCardsData } from "@/data/cards.data";
import BannerGradient from "./BannerGradient";
import StickyCard from "@/components/shared/cards/StickyCard";
import { servicesData } from "@/data/service.data";
import Image from "next/image";
import { TransitionLink } from "@/components/shared/TransitionLink";
import { useDict } from "@/components/providers/LocaleProvider";

const Banner = () => {
  const t = useDict();
  const showServices = servicesData.filter((s)=> s.isHomePage === true).slice(0, 4);
  return (
    <section className=" w-full max-md:pt-[100px] relative px-[5%]  grid pt-[100px] md:pt-[120px]  max-lg:h-fit max-lg:py-8 grid-cols-1 lg:grid-cols-2 min-[1745px]:h-screen min-[2000px]:h-[800px] max-h-[800px] mx-auto ">
      {/* Left   */}
      <div className=" absolute -bottom-5 w-full h-full bg-gradient-to-b from-black/5 to-background"></div>

      <section className="flex flex-col gap-y-8    justify-center h-full">
        <article className=" z-30  flex flex-col  gap-y-4  max-lg:justify-center max-lg:items-center">
          <p className="   bg-button text-sm  text-center    md:!text-base !text-white w-fit px-4 sm:px-8   py-1 rounded-full">
            {t.home.banner.titleTop}
          </p>
          <h1
            className=" banner-title   max-lg:text-center"
            style={{
              ...gradientTextLeftToRightStyles,
              fontSize: "36px",
            }}
          >
            <span>{t.home.banner.title1}</span>
            <br className=" hidden lg:block" />{" "}
            <span className=" max-lg:place-self-center w-fit mx-auto  ">
              {t.home.banner.title2}{" "}
            </span>
          </h1>
          <p className="  banner-description text-sm md:text-base max-lg:text-center">
            {t.home.banner.description}
          </p>
        </article>
        <section className="flex items-center justify-center z-50 lg:justify-start gap-x-4 relative">
          <TransitionLink href="/book-a-meeting">
            <button className=" cursor-pointer w-fit text-sm md:text-base lg:text-lg flex items-center justify-center rounded-full   !z-50  gap-1 bg-white text-black px-6 py-2  font-medium">
              {t.home.banner.reachOut}{" "}
              <IoIosArrowRoundUp className=" text-2xl  rotate-45 animate-bounce" />
            </button>
          </TransitionLink>
        </section>
      </section>

      {/* Right  */}
      <section className="grid-cols-2 hidden lg:grid  2xl:gap-8 relative">
        <BannerGradient />

        {showServices.map((card, idx) => {
          const copy = t.servicesPage.services[card.key];
          return (
            <StickyCard
              key={card.id}
              className={` min-[1800px]:w-[90%]  scale-[0.85] xl:scale-90   2xl:scale-100 !h-[270px]  2xl:!h-[300px] ${bannerCardsData[idx].className}`}
              title={copy.title}
              description={copy.bannerDescription}
              backgroundImage={card.bannerImage}
              icon={
                <Image
                  src={card.icon}
                  alt={copy.title + " Icon"}
                  width={40}
                  height={40}
                />
              }
              classNameForInnerParent={` ${bannerCardsData[idx].classNameForInnerParent}`}
              classNameForDot={` ${bannerCardsData[idx].classNameForDot}`}
            />
          );
        })}
      </section>
    </section>
  );
};

export default Banner;
